module.exports = __webpack_public_path__ + "img/bootstrap.d18c0ba0.png";